// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// 3rd party imports
import { DxDropDownButtonComponent, DxMenuComponent } from 'devextreme-angular';

// Model Imports
import { ActionMenuEvent, ActionMenuInfo } from '../_models/action-menu-info';

@Component({
    selector: 'app-grid-actions-menu',
    templateUrl: './grid-actions-menu.component.html',
    styleUrls: ['./grid-actions-menu.component.scss']
})
export class GridActionsMenuComponent<T> implements OnInit {
    @ViewChild('actionDropdownButton', { static: false }) actionDropdownButton: DxDropDownButtonComponent;
    @ViewChild('actionMenu', { static: false }) actionMenu: DxMenuComponent;

    @Input() actionMenuItems: Array<ActionMenuInfo>;
    @Input() record: T;
    @Input() rowIndex: number;
    @Input() isActionVisible: (item: ActionMenuInfo, record: T, rowIndex: number) => boolean;
    @Output() onActionClick = new EventEmitter<ActionMenuEvent<T>>();

    iconNext = IconConstants.NEXT;
    allowedActionMenus: Array<ActionMenuInfo>;
    elementId: string;

    constructor() {
        this.onItemClick = this.onItemClick.bind(this);
    }

    ngOnInit(): void {
        this.repaint();
        this.elementId = `actionMenu_${this.rowIndex}`;
    }

    onItemClick(item: ActionMenuInfo, record: T, rowIndex: number): void {
        this.onActionClick.emit({
            item,
            action: item.action,
            record,
            rowIndex,
            elementId: this.elementId
        });

        if (Utils.notNullAndDefined(this.actionDropdownButton)) {
            this.actionDropdownButton.instance.close();
        }
    }

    isItemVisible(item: ActionMenuInfo, record: T, rowIndex: number): boolean {
        if (Utils.notNullAndDefined(this.isActionVisible)) {
            return this.isActionVisible(item, record, rowIndex);
        }
        return true;
    }

    repaint(): void {
        this.allowedActionMenus = this.actionMenuItems.filter((item: ActionMenuInfo) =>
            this.isItemVisible(item, this.record, this.rowIndex)
        );
    }
}
